export const constants = {
    API_BASE: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
}
